module.exports = __webpack_public_path__ + "img/356.8b3ed3d7.svg";